// Avoid re-exports in favor of direct imports or entry-point files

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ImporterDashboardLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ImporterDashboardContainer" */ './ImporterDashboard.tsx'
			)
		).ImporterDashboard,
});
